import * as addons from "addons/index";

export { addons };
export default addons;
